export const GlobalTypes = {
  PERMISSION_LEVEL_E: 'EXPERT',
  PERMISSION_LEVEL_P: 'PLAIN',
};
